module.exports = __webpack_public_path__ + "img/Qina.2dfbe683.jpg";